export default __webpack_public_path__ + "static/media/smart_plating.22867601.png";